/*
 * Author: Alexandre Havrileck (Oxyno-zeta)
 * Date: 23/10/16
 * Licence: See Readme
 */

/* ************************************* */
/* ********       IMPORTS       ******** */
/* ************************************* */


/* ************************************* */
/* ********      VARIABLES      ******** */
/* ************************************* */
const ADD_DELTA_TYPE = 'ADD_DELTA_TYPE';
const REMOVE_DELTA_TYPE = 'REMOVE_DELTA_TYPE';
const UPDATE_DELTA_TYPE = 'UPDATE_DELTA_TYPE';

/* ************************************* */
/* ********  PRIVATE FUNCTIONS  ******** */
/* ************************************* */


/* ************************************* */
/* ********   PUBLIC FUNCTIONS  ******** */
/* ************************************* */


/* ************************************* */
/* ********       EXPORTS       ******** */
/* ************************************* */
export { ADD_DELTA_TYPE };
export { REMOVE_DELTA_TYPE };
export { UPDATE_DELTA_TYPE };
